import React, { useState } from 'react';
import { TextField } from '@mui/material';

export const formatAmount = (value) => {
  const num = Number(value);
  if (value === '' || value === null || value === undefined || isNaN(num)) return '';
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/**
 * Currency amount input: shows the clean, comma-formatted value ("50,000.00")
 * whenever the field isn't focused, but switches to the raw, unformatted
 * number while actively typing — so commas never fight the cursor, backspace,
 * or decimal entry. `value`/`onChange` always deal in the raw numeric string;
 * only the on-screen display differs by focus state.
 */
const AmountField = ({ value, onChange, label = 'Amount', helperText, ...props }) => {
  const [focused, setFocused] = useState(false);

  const handleChange = (e) => {
    let raw = e.target.value.replace(/[^0-9.]/g, '');
    const parts = raw.split('.');
    if (parts.length > 2) {
      raw = parts[0] + '.' + parts.slice(1).join('');
    }
    onChange(raw);
  };

  return (
    <TextField
      fullWidth
      margin="normal"
      label={label}
      value={focused ? value : formatAmount(value) || value}
      onChange={handleChange}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      inputMode="decimal"
      helperText={helperText}
      {...props}
    />
  );
};

export default AmountField;
